import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AirportPage } from './airport.page';

const routes: Routes = [
  {
    path: '',
    component: AirportPage
  },
  {
    path: 'airport-register',
    loadChildren: () => import('./airport-register/airport-register.module').then( m => m.AirportRegisterPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AirportPageRoutingModule {}
